// extracted by mini-css-extract-plugin
export default {"container":"MinuIframe_container__cX-BN","minuIframeCont":"MinuIframe_minuIframeCont__CmFE9"};